import React, {Component} from 'react'
import PropTypes from 'prop-types'
import LazyLoad from 'react-lazyload'

class ItemQuantity extends Component {
    render() {
        return (
            <td className='ItemQuantity'>
                <LazyLoad>
                    {this.props.quantity}
                </LazyLoad>
            </td>
        )
    }
}

ItemQuantity.propTypes = {
    quantity: PropTypes.number.isRequired,
}

export default ItemQuantity
